import "./Projects.module.css";
import NexoNavigation from "@/reusable_sections/Header";
import ProjectArchive from "./sections/ProjectArchive";
import CaseInsights from "./sections/CaseInsights";
import GlobalFooter from "@/reusable_sections/Footer";
export default function ProjectsPage() {
  return <div>
      <NexoNavigation />
      <ProjectArchive />
      <CaseInsights />
      <GlobalFooter />
    </div>;
}